export function redirectToLogin() {
    const protocol = window.location.protocol; // 获取当前页面的协议
    const isTest = process.env.NODE_ENV === 'development' || location.hostname.toLowerCase().indexOf('test') > -1;
    const base = isTest ? `${protocol}//test.xgjktech.com.cn/ai-voice-assistant/web/dist/` : `${protocol}//ai.mediportal.com.cn/`;
    const targetLink = `${base}#/login?redirect=%2FDesktopHome`;
    console.log('跳转链接:', targetLink);
    // window.open(targetLink, '_blank');
    window.location.href = targetLink;
} 